import {
    OrganizationActivityView,
    OrganizationActivityViewSchema,
} from "@common/types/views/organizationActivityView";
import { createDefaultOrganizationActivityView } from "@components/organizationView/activity/DefaultOrganizationActivityView";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

export function useOrganizationActivityViewStore() {
    return useViewStore<OrganizationActivityView>({
        defaultView: createDefaultOrganizationActivityView(),
        viewSchema: OrganizationActivityViewSchema,
        cacheKey:
            ORGANIZATION_USER_CACHE_KEYS.ORGANIZATION_ACTIVITY_PAGE_VIEW_CACHE_KEY,
    });
}
